import { Helmet } from "react-helmet";
import BreadCrumb from "../component/BreadCrumb";
import NativeLazyImage from "../component/NativeLazyImage";
import "./styles/AboutUsPage.style.css";
import { useEffect } from "react";
import { useState } from "react";
import AxiosClient from "./../client/AxiosClient";
import { API_CUSTOM_PAGE } from "./../ApiEndPoints";
import RawHTML from "../component/RawHTML";
import Loader from "./../component/Loader";
import { useParams } from "react-router-dom";
import "./styles/ckeditor5-content.css";

export default function CustomPage() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  const params = useParams();
  const slug = params.slug;

  useEffect(() => {
    AxiosClient.get(`${API_CUSTOM_PAGE}${slug}`)
      .then((response) => {
        if (response.data.success == false) {
          window.location.href = "/page-not-found";
        }

        const pageData = response.data.data;

        setData(pageData);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [slug]);

  return (
    <main>
      <Helmet>
        <title> {data?.name || "Loading ..."}</title>
        <meta name="keywords" content={data?.meta_keywords || ""} />
        <meta name="description" content={data?.meta_description || ""} />
      </Helmet>

      {/* <BreadCrumb title={data?.name || "Loading"} desc="" /> */}

      <section className="pt-0">
        <div className="container">
          {loading ? (
            <div className="text-center">
              <Loader />
            </div>
          ) : (
            <div className="ck-content">
              <RawHTML rawHTML={data?.content} />
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
